import { render, staticRenderFns } from "./UIInputCheckbox.vue?vue&type=template&id=e1b2fe80&"
import script from "./UIInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./UIInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports